/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIStatusDaeEnum } from './APIStatusDaeEnum';
import {
    APIStatusDaeEnumFromJSON,
    APIStatusDaeEnumFromJSONTyped,
    APIStatusDaeEnumToJSON,
} from './APIStatusDaeEnum';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APISupplyOrderRequest
 */
export interface APISupplyOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof APISupplyOrderRequest
     */
    supplier: string;
    /**
     * 
     * @type {string}
     * @memberof APISupplyOrderRequest
     */
    article: string;
    /**
     * 
     * @type {APIStatusDaeEnum}
     * @memberof APISupplyOrderRequest
     */
    status?: APIStatusDaeEnum;
    /**
     * 
     * @type {Date}
     * @memberof APISupplyOrderRequest
     */
    dueDate: Date;
    /**
     * 
     * @type {string}
     * @memberof APISupplyOrderRequest
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof APISupplyOrderRequest
     */
    unit?: string;
    /**
     * 
     * @type {string}
     * @memberof APISupplyOrderRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof APISupplyOrderRequest
     */
    comment?: string;
    /**
     * 
     * @type {boolean}
     * @memberof APISupplyOrderRequest
     */
    approval?: boolean;
}



/**
 * Check if a given object implements the APISupplyOrderRequest interface.
 */
export function instanceOfAPISupplyOrderRequest(value: object): value is APISupplyOrderRequest {
    if (!('supplier' in value) || value['supplier'] === undefined) return false;
    if (!('article' in value) || value['article'] === undefined) return false;
    if (!('dueDate' in value) || value['dueDate'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function APISupplyOrderRequestFromJSON(json: any): APISupplyOrderRequest {
    return APISupplyOrderRequestFromJSONTyped(json, false);
}

export function APISupplyOrderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APISupplyOrderRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'supplier': json['supplier'],
        'article': json['article'],
        'status': json['status'] == null ? undefined : APIStatusDaeEnumFromJSON(json['status']),
        'dueDate': (new Date(json['due_date'])),
        'amount': json['amount'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'description': json['description'] == null ? undefined : json['description'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'approval': json['approval'] == null ? undefined : json['approval'],
    };
}

export function APISupplyOrderRequestToJSON(value?: APISupplyOrderRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'supplier': value['supplier'],
        'article': value['article'],
        'status': APIStatusDaeEnumToJSON(value['status']),
        'due_date': ((value['dueDate']).toISOString()),
        'amount': value['amount'],
        'unit': value['unit'],
        'description': value['description'],
        'comment': value['comment'],
        'approval': value['approval'],
    };
}

